@use '@lib/assets/styles/main.scss' as *;
.actions {
  padding-top: 32px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}
